import { Emitter, Event } from "../../../../../features/event-emitter"
import { useDeliveryService } from "../../../services/deliveryService"

export const useActions = () => {
    const { uploadDeliveryNoteFile } = useDeliveryService()

    const submitDeliveryNote = async (
        deliveryId: string,
        deliveryNoteFile: File,
        onUpload: () => Promise<void>
    ) => {
        Emitter.emit(Event.DB_SUBMIT)

        await uploadDeliveryNoteFile(deliveryId, deliveryNoteFile)
        await onUpload()
        
        Emitter.emit(Event.DB_SUBMIT_DONE, false, false)
    }

    return {
        submitDeliveryNote
    }
}
